import * as index from './index';
index.Calendar.Inject(index.Islamic);
index.DatePicker.Inject(index.Islamic);
index.DateTimePicker.Inject(index.Islamic);
export * from './index';
